import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import UserDto from '@/models/Users/UserDto';
import EntityType from '@/models/Shared/EntityType';
import GeneralStatus from '@/models/Shared/GeneralStatus';
import NoteType from '@/models/Notes/NoteType';
import NoteCategoryDto from '../NoteCategories/NoteCategoryDto';

export default class NoteDto extends BaseAgencyScopeEntityDto {
    createdBy: UserDto = new UserDto();
    lastUpdatedBy: UserDto = new UserDto();
    entityId = '';
    entityType: EntityType
    status: GeneralStatus = GeneralStatus.ActiveOrApproved;
    description: string;
    type: NoteType;
    noteCategoryId: string;
    noteCategory: NoteCategoryDto = null;

}